import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useContext } from 'react';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { Component as AssetProvider } from '../AssetProvider';
import { assetPropType } from '../utils';
import { colorStyles, highlightStyles } from '../styles';
import logger from '../logger';
var debug = logger.extend('HTMLAsset');
var AssetInspector = dynamic(() => import(
/* webpackChunkName: "AssetInspector" */
'../AssetInspector'), {
  loading: () => null
});
var Wrapper = styled.div.withConfig({
  displayName: "HTMLAsset__Wrapper",
  componentId: "sc-z0cu3d-0"
})(["\n  position: relative;\n  display: flex;\n  ", "\n  ", "\n"], colorStyles, highlightStyles);
var Content = styled.div.withConfig({
  displayName: "HTMLAsset__Content",
  componentId: "sc-z0cu3d-1"
})(["\n  width: 100%;\n"]);
export default function HTMLAsset(_ref) {
  var asset = _ref.asset,
      rest = _objectWithoutProperties(_ref, ["asset"]);

  var _useContext = useContext(AssetProvider.Context),
      highlightAssets = _useContext.highlightAssets;

  var backgroundColor = asset.options.bgColor || undefined;
  var textColor = // Encourage migration to `textColor` spelling instead of `textcolor`, but
  // support both.
  asset.options.customVars.textColor || asset.options.customVars.textcolor || undefined;
  var title = highlightAssets ? "".concat(asset.container.name, ": ").concat(asset.label || asset.id) : undefined;

  if (debug.enabled) {
    var invalidProp = ['background', 'aspectRatio'].find(prop => rest[prop] != null);

    if (invalidProp) {
      debug('HTML asset %c%s%c rendered with prop %c%s%c,%c but this only applies to image assets.', 'font-weight: bold', asset.container.name, '', 'font-weight: bold; white-space: nowrap', invalidProp, 'font-weight: normal', '');
    }
  }

  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    backgroundColor: backgroundColor,
    highlightAssets: highlightAssets,
    textColor: textColor,
    title: title
  }, rest), /*#__PURE__*/React.createElement(Content // Use an attribute selector with this to target the HTML with CSS.
  , {
    "data-asset-html": "",
    dangerouslySetInnerHTML: {
      __html: asset.options.htmlText
    }
  }), highlightAssets ? /*#__PURE__*/React.createElement(AssetInspector, {
    asset: asset
  }) : null);
}
HTMLAsset.propTypes = {
  asset: assetPropType
};